import React from "react";
import Layout from "../../components/layout/Layout";
import SalaryTab from "./SalaryTab";

function Salary({ children }) {
  return (
    <>
      <div className="pt-4 pb-10">
        <div className="sticky top-16 w-full h-full  z-40">
          <SalaryTab />
        </div>
        {children}
      </div>
    </>
  );
}

export default Salary;
